import { history } from 'umi';
import { clearAuth, getAuth } from './db';
import { getLocalItem } from './tools';

export const LOGIN_PATH = '/user/login';
export const PROTECTED_PREFIXES = ['/dashboard', '/assets', '/mine', '/message'];
export const LOGIN_REDIRECT_CODES = [401, 409];

let clearUserStateHandler = null;

export const registerAuthHandlers = ({ clearUserState }) => {
  clearUserStateHandler = clearUserState;
};

export const isProtectedPath = (pathname = '') =>
  PROTECTED_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );

export const hasLocalToken = () => !!getAuth();

export const clearAuthSession = () => {
  clearAuth();
  clearUserStateHandler?.();
};

export const redirectToLogin = (options = {}) => {
  const { redirectPath, msg, showToast } = options;
  const { pathname, search, query } = history.location;

  if (pathname === LOGIN_PATH) {
    return false;
  }

  clearAuthSession();

  const currentPath = redirectPath || `${pathname}${search || ''}`;
  const redirect =
    currentPath && currentPath !== LOGIN_PATH
      ? encodeURIComponent(currentPath)
      : undefined;
  const invite = getLocalItem('invite');

  history.push({
    pathname: LOGIN_PATH,
    query: {
      ...(invite ? { invite } : {}),
      ...(redirect ? { redirect } : {}),
    },
  });

  return true;
};

export const isLoginRedirectStatus = (status) =>
  LOGIN_REDIRECT_CODES.includes(Number(status));

export const parseUserInfoResponse = (response) => {
  if (!response) return undefined;
  if (isLoginRedirectStatus(response.status)) return undefined;
  if (response.status === 1) return response.data;
  return undefined;
};
